import { useAuth } from 'context/AuthContext';
import { BiLogOut } from 'react-icons/bi';
import Logo from '../../assets/img/logo.png';

function formatarData(valor: any): string | null {
  const millis = typeof valor === 'object' && valor?.$date ? valor.$date : valor;
  const data = millis ? new Date(millis) : null;

  if (!data || isNaN(data.getTime())) return null;

  return data.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
}

/**
 * Tela de conta desativada. Renderizada pelo `PrivateRoute`, então cobre todas
 * as rotas protegidas — e não só a home, como uma guarda dentro do `Dashboard`
 * cobriria.
 *
 * Não consulta nada: com `player_fields.active` desligado, o `prepare()` de 66
 * agregados barra o chamador e devolve lista vazia — inclusive o `find/info`.
 * Tudo que aparece aqui vem do `user` de `/player/me/status`, que não é agregado.
 */
export function ContaDesativada() {
  const { user, signOut } = useAuth();

  /* `extra.optout` é carimbado pelo trigger da saída voluntária. Sem ele, a
     conta foi desativada por outro caminho (carga de RH, ação administrativa) e
     dizer "você pediu para sair" seria mentira para quem não pediu. */
  const saiuPorContaPropria = user?.extra?.optout === true;
  const desde = formatarData(user?.extra?.optout_em);
  const primeiroNome = user?.name?.split(' ')[0];

  return (
    <div className="absolute left-0 right-0 min-h-full m-auto px-5 md:w-1/2 xl:w-1/3 2xl:w-1/3 flex flex-col items-center justify-center">
      <div>
        <img src={Logo} className="pointer-events-none h-36 lg:h-48" alt="Reconheça BRB" />
      </div>

      <div className="w-full mt-5 text-center text-yellow font-bold text-2xl">
        {primeiroNome ? `${primeiroNome}, sua` : 'Sua'} conta está desativada no Reconheça BRB.
      </div>

      <div className="my-4 w-full border-t border-white"></div>

      <p className="text-center">
        {saiuPorContaPropria ? (
          <>
            Você pediu para não participar mais{desde ? ` em ${desde}` : ''}.
            <br />
            Por isso não aparece nas buscas e não envia nem recebe reconhecimentos.
          </>
        ) : (
          <>
            Sua conta não está ativa no programa no momento.
            <br />
            Por isso não aparece nas buscas e não envia nem recebe reconhecimentos.
          </>
        )}
      </p>

      <p className="text-center mt-4">
        Os reconhecimentos que você já trocou continuam no mural —<br className="hidden lg:block" /> eles foram
        escritos por colegas e não são apagados.
      </p>

      <p className="text-center mt-4">
        Para voltar a participar, peça à <strong>moderação do Reconheça</strong>
        <br className="hidden lg:block" /> que reative a sua conta.
      </p>

      <div className="mt-8">
        <button
          onClick={() => signOut()}
          className="uppercase flex flex-row items-center space-x-1 bg-yellow text-blue-dark p-3 rounded-full"
        >
          <span>ENCERRAR SESSÃO</span>
          <BiLogOut />
        </button>
      </div>
    </div>
  );
}
